import { client } from './client'
import { statusFilterRequest } from './statusFilterRequest'
import type {
  TestCase,
  TestCaseDetail,
  TestCaseFilters,
  PaginationParams,
  PagedResult,
  UpdateTestCaseRequest,
  TestCaseAutomationLink,
  TestRun,
  TestRunFilters,
  PushTestCaseRequest,
  PushTestCasesRequest,
  PushTestItemsResponse,
} from '@/types'

export const testCasesApi = {
  getByWorkItem: (projectId: string, workItemId: string, params?: PaginationParams & TestCaseFilters) =>
    client.get<PagedResult<TestCase>>(`/projects/${projectId}/work-items/${workItemId}/test-cases`, statusFilterRequest(params)).then(r => r.data),

  getByTestSuite: (projectId: string, testSuiteId: string, params?: PaginationParams & TestCaseFilters) =>
    client.get<PagedResult<TestCase>>(
      `/projects/${projectId}/test-suites/${testSuiteId}/test-cases`,
      statusFilterRequest(params),
    ).then(r => r.data),

  getById: (projectId: string, testCaseId: string) =>
    client.get<TestCaseDetail>(`/projects/${projectId}/test-cases/${testCaseId}`).then(r => r.data),

  update: (projectId: string, testCaseId: string, data: UpdateTestCaseRequest) =>
    client.put<{ testCaseId: string }>(`/projects/${projectId}/test-cases/${testCaseId}`, data).then(r => r.data),

  delete: (projectId: string, testCaseId: string) =>
    client.delete(`/projects/${projectId}/test-cases/${testCaseId}`).then(r => r.data),

  getAutomationLinks: (projectId: string, testCaseId: string) =>
    client.get<TestCaseAutomationLink[]>(`/projects/${projectId}/test-cases/${testCaseId}/automation-links`).then(r => r.data),

  getRuns: (projectId: string, testCaseId: string, params?: PaginationParams & TestRunFilters) =>
    client.get<PagedResult<TestRun>>(`/projects/${projectId}/test-cases/${testCaseId}/runs`, { params }).then(r => r.data),

  pushToDevOps: (projectId: string, testCaseId: string, data: PushTestCaseRequest) =>
    client.post<PushTestItemsResponse>(
      `/projects/${projectId}/test-cases/${testCaseId}/push-to-devops`,
      data,
    ).then(r => r.data),

  pushManyToDevOps: (projectId: string, data: PushTestCasesRequest) =>
    client.post<PushTestItemsResponse>(
      `/projects/${projectId}/test-cases/push-to-devops`,
      data,
    ).then(r => r.data),
}
